// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { EventTypes } from "./event-types";

export class EventKey implements flatbuffers.IUnpackableObject<EventKeyT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): EventKey {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  types(): EventTypes {
    return this.bb!.readUint8(this.bb_pos);
  }

  eventId(): number {
    return this.bb!.readUint32(this.bb_pos + 4);
  }

  static sizeOf(): number {
    return 8;
  }

  static createEventKey(
    builder: flatbuffers.Builder,
    types: EventTypes,
    event_id: number,
  ): flatbuffers.Offset {
    builder.prep(4, 8);
    builder.writeInt32(event_id);
    builder.pad(3);
    builder.writeInt8(types);
    return builder.offset();
  }

  unpack(): EventKeyT {
    return new EventKeyT(this.types(), this.eventId());
  }

  unpackTo(_o: EventKeyT): void {
    _o.types = this.types();
    _o.eventId = this.eventId();
  }
}

export class EventKeyT implements flatbuffers.IGeneratedObject {
  constructor(
    public types: EventTypes = EventTypes.Log,
    public eventId: number = 0,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    return EventKey.createEventKey(builder, this.types, this.eventId);
  }

  clone(): EventKeyT {
    const obj = new EventKeyT();
    obj.types = this.types;
    obj.eventId = this.eventId;
    return obj;
  }

  equals(other: EventKeyT): boolean {
    if (this.types !== other.types) return false;
    if (this.eventId !== other.eventId) return false;
    return true;
  }
}
